import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { Observable } from 'rxjs';
import {
  CreateUserDto,
  EditUserDto,
  UserInfoDto,
  UserListDto,
} from '../models/user-models';
import { UserInfoService } from '../../../services/user-info.service';
import { SortTableService } from '../../../services/sort-table.service';
import { FilterSearchResultDto } from 'src/app/models/filter.model';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  agentId: string | undefined;
  userId: number | undefined;

  sort: string | undefined;

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService,
    private sortTableService: SortTableService
  ) {
    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res;
      },
    });

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res;
      },
    });

    this.sortTableService.sortColum$.subscribe({
      next: (res) => {
        this.sort = res;
      },
    });
  }

  loadUserFilter(): Observable<any> {
    const url = `/agents/${this.agentId}/users/filter`;
    return this.apiService.httpGet<any>(url);
  }

  loadUserInfo(userId: number): Observable<UserInfoDto> {
    const url = `/agents/${this.agentId}/users/${userId}/profile`;
    return this.apiService.httpGet<UserInfoDto>(url);
  }

  loadUserList(
    page: number,
    search: string | undefined = '',
    data?: any
  ): Observable<UserListDto> {
    const url = `/agents/${this.agentId}/users/filter?page_number=${page}&per_page=20&${this.sort}&search=${search}`;
    return this.apiService.httpPost<UserListDto>(url, data);
  }

  loadSearchList(data: any): Observable<FilterSearchResultDto> {
    const url = `/agents/${this.agentId}/users/filter/list?page_number=0&per_page=10`;
    return this.apiService.httpPost<FilterSearchResultDto>(url, data);
  }

  createUser(userData: CreateUserDto): Observable<void> {
    const url = `/agents/${this.agentId}/users`;
    return this.apiService.httpPost<void>(url, userData);
  }

  changeStatusUser(ids: string, state: boolean): Observable<void> {
    const url = `/agents/${this.agentId}/users/enabled?users_ids=${ids}&enabled=${state}`;
    return this.apiService.httpPatch<void>(url);
  }

  deleteUsers(userList: string) {
    const url = `/agents/${this.agentId}/users?users_ids=${userList}`;
    return this.apiService.httpDelete<void>(url);
  }

  editUser(id: number, body: EditUserDto): Observable<void> {
    const url = `/agents/${this.agentId}/users/${id}`;
    return this.apiService.httpPut<void>(url, body);
  }

  resetPasswordEmail(id: string) {
    const url = `/agents/${this.agentId}/users/passwords/reset?users_ids=${id}`;
    return this.apiService.httpDelete<void>(url);
  }

  resetSession(id: string) {
    const url = `/agents/${this.agentId}/users/sessions/reset?users_ids=${id}`;
    return this.apiService.httpDelete<void>(url);
  }

  loadFile(): Observable<Blob> {
    const url = `/agents/${this.agentId}/reports/users/download`;
    return this.apiService.httpGetBlob(url);
  }
}
